import React, { useState } from 'react';
import Field from '@cpg-its/ads.form.field';
import { useDispatch } from 'react-redux';
import { FieldArray, FieldArrayRenderProps, FormikProps } from 'formik';
import { TcsmModal } from '../../../../../../global/components/tcsm-modal';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { CoveragePerson, CoveragePlans, DeclinedValue, PlanTypes } from '../models/coverage-models';
import { SelfText } from '../../../../../annual-enrollment/models/annual-enrollment-models';
import { getRelationshipLabel } from '../helpers/coverage-display-helpers';
import { ConfirmCancelModalContent } from '../../../../../../global/components/confirm-cancel-dialog-content';
import { setNewHireTier } from '../../slice/new-hire-enrollment-slices';
import { calculateTiers } from '../helpers/coverage-form-helpers';
import { getFormattedDate } from '../../../../../../global/helpers/date-helpers';


interface Props {
	planType: PlanTypes;
	fieldName: string;
	groupLabel: string;
	settings: NewHireProps;
	formProps: FormikProps<any>;
	eligibleDependents: CoveragePerson[];
	plan: CoveragePlans;
	setRemoveSelfFlag: any;
	setReselectSelfFlag: any;
	removeSelfDialogGroup: PlanTypes;
	reselectSelf: PlanTypes;
	displayPlanSelectionDioApprover?: boolean;
}
export function PersonCoverage(props: Props) {

	const { planType, fieldName, groupLabel, settings, formProps, eligibleDependents, plan, setRemoveSelfFlag, setReselectSelfFlag, removeSelfDialogGroup, reselectSelf, displayPlanSelectionDioApprover } = props;
	const dispatch = useDispatch();

	const [personPickedWithNoSelf, setPersonPickedWithNoSelf] = useState<string>(null);

	const confirmUnselectSelf = () => {
		formProps.setFieldValue(planType, DeclinedValue);
		formProps.setFieldValue(fieldName, []);
		setRemoveSelfFlag(PlanTypes.None);
		dispatch(setNewHireTier(planType, null));

	};

	const confirmSelectSelf = (selectedPerson: string) => {
		const newValues = [SelfText, selectedPerson];

		formProps.setFieldValue(fieldName, newValues);
		setReselectSelfFlag(PlanTypes.None);

		calculateTiers(plan, newValues, dispatch, eligibleDependents, planType);
	};


	const onCheckboxChange = (e, fieldArrayProps: FieldArrayRenderProps) => {
		const values = formProps.values[fieldName];
		const { value } = e.target;
		if (e.target.checked) {
			if (value !== SelfText && !values.includes(SelfText)) {
				setReselectSelfFlag(planType);
				setPersonPickedWithNoSelf(value);
			} else {
				fieldArrayProps.push(value);
				calculateTiers(plan, [...values, value], dispatch, eligibleDependents, planType);

			}
		} else if (value === SelfText) {
			setRemoveSelfFlag(planType);
		} else {
			fieldArrayProps.remove(values.indexOf(value));
			calculateTiers(plan, values.filter(x => x !== value), dispatch, eligibleDependents, planType);
		}
	};

	if (!displayPlanSelectionDioApprover) {
		return null;
	}

	return (
		<>
			<FieldArray
				name={fieldName}
				render={(fieldArrayProps) => (
					<>
						<ContentSpacer>
							<h4>{groupLabel}</h4>
						</ContentSpacer>
						<Field
							id={`${fieldName}-self`}
							name={fieldName}
							label={settings?.selfOptionText}
							component='checkBox'							
							value={SelfText}
							checked={formProps?.values[fieldName]?.includes(SelfText)}
							checkBoxGroup
							onChange={(e) => onCheckboxChange(e, fieldArrayProps)}
						/>
						{eligibleDependents?.map(dep => {
							const dependentCurrentlyEnrolled = plan?.current?.dependents?.includes(dep?.guid);
							const dependentChecked = !dep?.remove && formProps?.values[fieldName]?.includes(dep?.guid);

							return (
								<>
									<Field
										id={`${planType}-${dep.guid}`}
										key={`${planType}-${dep.guid}`}
										name={fieldName}
										label={`${dep?.first_name} ${dep?.middle_name} ${dep?.last_name}  ${dep?.suffix}`}
										description={getRelationshipLabel(dep?.relationship, settings)}
										component='checkBox'
										value={dep?.guid}
										checked={dependentChecked}
										disabled={!!dep?.remove}
										checkBoxGroup
										onChange={(e) => onCheckboxChange(e, fieldArrayProps)} />
									{
										!!dep?.remove && dependentCurrentlyEnrolled &&
										<p className='red-text'><strong>{settings?.ineligibleDependentsWarning?.replace('{date}', getFormattedDate(plan?.effective_date))}</strong></p>
									}

								</>
							);
						})}
					</>
				)}
			/>

			<TcsmModal
				open={removeSelfDialogGroup === planType}
				handleClose={() => setRemoveSelfFlag(PlanTypes.None)}>

				<ConfirmCancelModalContent
					description={settings?.unselectSelfModalMessage}
					confirmAction={{
						action: () => confirmUnselectSelf(),
						label: settings?.unselectSelfConfirmText,
					}}
					cancelAction={{
						action: () => setRemoveSelfFlag(PlanTypes.None),
						label: settings?.unselectSelfCancelText,
					}}
				/>
			</TcsmModal>

			<TcsmModal
				open={reselectSelf === planType}
				handleClose={() => setReselectSelfFlag(PlanTypes.None)}>

				<ConfirmCancelModalContent
					description={settings?.selectSelfModalMessage}
					confirmAction={{
						action: () => confirmSelectSelf(personPickedWithNoSelf),
						label: settings?.selectSelfConfirmText,
					}}
					cancelAction={{
						action: () => {
							setReselectSelfFlag(PlanTypes.None);
							setPersonPickedWithNoSelf(null);
						},
						label: settings?.selectSelfCancelText,
					}}
				/>
			</TcsmModal>
		</>
	);
}


PersonCoverage.defaultProps = {
	displayPlanSelectionDioApprover: false,
};